/* istanbul ignore file */

import React, { useState, useEffect } from 'react';
import compose from 'lodash/fp/compose';
import { withMetrics } from '@catalogo/core-metrics';

const sortOptions = [
  { filter: 'Helpfulness:desc', name: 'mais relevantes' },
  { filter: 'SubmissionTime:desc', name: 'mais recentes' },
  { filter: 'SubmissionTime:asc', name: 'mais antigas' },
  { filter: 'Rating:desc', name: 'mais positivas' },
  { filter: 'Rating:asc', name: 'mais negativas' },
];

const ratingsOptions = [
  { filter: null, name: 'todas as notas', label: '' },
  { rating: 5, filter: ['Rating:eq:5'], name: 'notas 5 estrelas', label: '5 estrelas' },
  { rating: 4, filter: ['Rating:eq:4'], name: 'notas 4 estrelas', label: '4 estrelas' },
  { rating: 3, filter: ['Rating:eq:3'], name: 'notas 3 estrelas', label: '3 estrelas' },
  { rating: 2, filter: ['Rating:eq:2'], name: 'notas 2 estrelas', label: '2 estrelas' },
  { rating: 1, filter: ['Rating:eq:1'], name: 'notas 1 estrela', label: '1 estrela' },
];

const withFilter = Component => props => {
  const { fetchMore, hasReviews, ratingDistribution, dispatchMetrics } = props;
  const [hasReview, setHasReview] = useState(false);
  const [bySort, setBySort] = useState(sortOptions[0]);
  const [byRating, setByRating] = useState(ratingsOptions[0]);
  const willMount = React.useRef(false);

  useEffect(() => {
    setHasReview(hasReviews);
  }, []);

  const prepareRatingsOptions = () => {
    const ratings = ratingsOptions
      .filter(item => item.filter !== null)
      .map(item => ({
        ...item,
        countReview: ratingDistribution[`rating${item.rating}`].count,
      }));
    return [ratingsOptions[0], ...ratings];
  };

  const onChangeSort = sort => {
    dispatchMetrics('event:track', {
      category: 'product',
      action: 'Avaliações - Filtro',
      label: sort.name,
    });
    setBySort(sort);
  };

  const onChangeRating = rating => {
    dispatchMetrics('event:track', {
      category: 'product',
      action: rating.eventAction,
      label: rating.name,
    });
    setByRating(rating);
  };

  useEffect(() => {
    if (willMount.current) {
      sortBy();
    } else {
      willMount.current = true;
    }
  }, [bySort, byRating]);

  const sortBy = () => {
    fetchMore({
      variables: { sort: bySort.filter, filters: byRating.filter },
      updateQuery: (prev, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  return (
    <Component
      {...props}
      hasReview={hasReview}
      onChangeSort={onChangeSort}
      onChangeRating={onChangeRating}
      sortOptions={sortOptions}
      ratingsOptions={prepareRatingsOptions()}
      starCountFeedback={byRating.label}
      stateSort={bySort}
      stateRating={byRating}
    />
  );
};

export default compose(withMetrics, withFilter);
